type RuntimeEnvironment = Record<string, string | boolean | undefined>;
type RuntimeGlobal = typeof globalThis & { __IMPORT_META_ENV__?: RuntimeEnvironment };

function resolveBase(): string {
  const runtimeEnv = (globalThis as RuntimeGlobal).__IMPORT_META_ENV__ ?? {};
  const rawBase = String(runtimeEnv?.VITE_API_BASE ?? '').trim();
  const isInternalApiHost = /^https?:\/\/nebula-api(?::\d+)?/i.test(rawBase);

  if (!rawBase || isInternalApiHost) {
    return '/api';
  }

  return rawBase;
}

export function apiBase(path: string = ''): string {
  const base = resolveBase();
  if (!path) return base;
  const normalizedBase = base.replace(/\/+$/, '');
  const normalizedPath = path.replace(/^\/+/, '');
  return `${normalizedBase}/${normalizedPath}`;
}

export { resolveBase as __resolveApiBase }; // exported for testing

